import { GroupIds } from "@/configuration/group-ids";
import { entpartnersSmsRoutingConfig } from "@/configuration/groups/entpartners/scheduling/sms/routing";
import {
  SchedulingCancellationStrategy,
  type SchedulingCustomerConfig,
  SchedulingSmsAvailabilityStrategy,
  SchedulingSmsEligibilityStrategy,
  SchedulingVoiceWorkflow,
} from "@/customer-interface/scheduling";

/** Live Voice also requires the backend rollout switch and agent opt-in; SMS uses the cohorts below. */
export const entpartnersSchedulingConfig = {
  appointmentQuery: {
    enabledGroupIds: { VOICE: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX] },
  },
  locationQuery: {
    enabledGroupIds: {
      SMS: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX, GroupIds.ENT_PARTNERS_LIVE],
      VOICE: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
    },
  },
  policy: {
    scheduleConfigPath: "configuration/groups/entpartners/rules/schedule.yaml",
  },
  voice: {
    workflow: SchedulingVoiceWorkflow.Deterministic,
    workflowEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX, GroupIds.ENT_PARTNERS_LIVE],
    cancellation: SchedulingCancellationStrategy.Direct,
    optionSearch: {
      progressiveChronologicalWindows: true,
      progressivePolicyRankedWindows: false,
      progressiveLinkedUnitWindows: false,
    },
  },
  // SMS appointment reads retain their current path.
  sms: {
    routing: entpartnersSmsRoutingConfig,
    eligibility: SchedulingSmsEligibilityStrategy.Agentic,
    eligibilityEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX, GroupIds.ENT_PARTNERS_LIVE],
    availability: SchedulingSmsAvailabilityStrategy.AgenticProvider,
    availabilityEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX, GroupIds.ENT_PARTNERS_LIVE],
    bookingEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX, GroupIds.ENT_PARTNERS_LIVE],
  },
} as const satisfies SchedulingCustomerConfig;
